import React, { useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import { styled } from "@mui/material/styles";

const StyledTabs = styled(Tabs)(({ theme }) => ({
  "& .MuiTabs-flexContainer": {
    justifyContent: "flex-start",
  },
  "& .MuiTab-root": {
    textTransform: "none",
    fontSize: "0.9rem",
    fontWeight: "600",
    padding: "10px 16px",
    marginRight: "4px",
    // borderRadius: "16px 16px 0 0",
    borderRadius: 5,
    transition: "background-color 0.3s, transform 0.3s",
    "&:hover": {
      backgroundColor: "#f0f0f0",
      transform: "scale(1.05)",
    },
    "&.Mui-selected": {
      backgroundColor: "#ffffff",
      color: "#003366",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    },
  },
  "& .MuiTabs-indicator": {
    backgroundColor: "#003366",
    height: "2px",
  },
}));

const TabPage = () => {
  const location = useLocation();
  const [selectedTab, setSelectedTab] = useState(location.pathname);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <div className=" bg-cream flex flex-col items-center">
      <Box className="w-full  bg-white shadow-lg  rounded-lg overflow-hidden	p-0">
        <StyledTabs
          value={selectedTab}
          onChange={handleChange}
          aria-label="Config Tabs"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab
            label="General"
            className="capitalize text-lg"
            component={Link}
            to=""
            value={"/config"}
          />
          <Tab
            label="Endpoint"
            className="capitalize text-lg"
            component={Link}
            to="endpoint"
            value={"/config/endpoint"}
          />
          <Tab
            label="Performance"
            className="capitalize text-lg"
            component={Link}
            to="performance"
            value={"/config/performance"}
          />
          <Tab
            label="Security"
            className="capitalize text-lg"
            component={Link}
            to="security"
            value={"/config/security"}
          />
          <Tab
            label="Log Monitor"
            className="capitalize text-lg"
            component={Link}
            to="logmonitor"
            value={"/config/logmonitor"}
          />

          <Tab
            label="Resource Scheduler"
            className="capitalize text-lg"
            component={Link}
            to="resourceScheduler"
            value={"/config/resourceScheduler"}
          />
          <Tab
            label="Cost Management"
            className="capitalize text-lg"
            component={Link}
            to="costManagement"
            value={"/config/costManagement"}
          />
          <Tab
            label="Release Notes"
            className="capitalize text-lg"
            component={Link}
            to="release"
            value={"/config/release"}
          />
        </StyledTabs>
        <Outlet />
      </Box>
    </div>
  );
};

export default TabPage;
